export const SCHEDULE_BLOCK_REASON = {
  INTAKE_FORM_COMPLETED_TOO_RECENTLY: "intake_form_completed_too_recently",
  ALREADY_SCHEDULED: "already_scheduled",
} as const;
